import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ArrowRightLeft, Clock, Upload } from 'lucide-react';

export default function ImportTransactionsPage(): React.ReactElement {
  const [showComingSoon, setShowComingSoon] = useState(true);

  return (
    <div className="flex h-full flex-col">
      {/* Header */}
      <div className="border-b bg-card p-6">
        <div className="flex items-center gap-2">
          <Upload className="h-6 w-6 text-primary" />
          <h1 className="text-2xl font-bold tracking-tight">Import Transactions</h1>
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          Import transaction history and financial data in bulk
        </p>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto">
        <div className="space-y-6 p-6">

      <Card>
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
              <ArrowRightLeft className="h-6 w-6 text-primary" />
            </div>
            <div>
              <CardTitle>Transaction Import</CardTitle>
              <CardDescription>
                Bulk import transactions including additions, depreciation, and revaluations
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center py-12">
            <div className="text-center">
              <Clock className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
              <h3 className="text-lg font-semibold mb-2">Coming Soon</h3>
              <p className="text-muted-foreground mb-4">
                Transaction import functionality is currently under development.
              </p>
              <Button variant="outline" disabled>
                Import Transactions
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      <Dialog open={showComingSoon} onOpenChange={setShowComingSoon}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Clock className="h-5 w-5" />
              Coming Soon
            </DialogTitle>
            <DialogDescription asChild>
              <div className="text-sm text-muted-foreground pt-4">
                The transaction import feature is currently under development and will be available in a future update.
                <br /><br />
                This feature will allow you to:
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Import transaction records from CSV files</li>
                  <li>Support for additions, depreciation, and revaluations</li>
                  <li>Background processing with progress tracking</li>
                  <li>Validation and error reporting</li>
                </ul>
              </div>
            </DialogDescription>
          </DialogHeader>
          <div className="flex justify-end">
            <Button onClick={() => setShowComingSoon(false)}>
              Got it
            </Button>
          </div>
        </DialogContent>
      </Dialog>
        </div>
      </div>
    </div>
  );
}
